/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Icon, DateField } from '@jutro/components';
import styles from './UASTableComponent.module.scss';
import metadata from './UASTableComponent.metadata.json5';

function UASTableComponent(props) {

    const {
        data: UASTableVM,
        updateWizardData,
        submissionVM,
        UASTablePath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addUASTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            UASTableVM.value = UASTableVM.value || []

            const { _xCenter, _dtoName } = UASTableVM;

            const UASTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            UASTableObjVM.isValidationReq = true;

            UASTableVM.pushElement(
                UASTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, UASTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            UASTableVM.value.splice(index, 1);
            _.set(submissionVM.value, UASTablePath, UASTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, UASTablePath, UASTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'year') {
                const value = item.year ? item.year : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.year = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'make') {
                const value = item.make ? item.make : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.make = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'model') {
                const value = item.model ? item.model : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.model = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'serNum') {
                const value = item.serNum ? item.serNum : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.serNum = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'maxWei') {
                const value = item.maxWei ? item.maxWei : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.maxWei = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'insHulVal') {
                const value = item.insHulVal ? item.insHulVal : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.insHulVal = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`UASTableTable`]: {
            data: UASTableVM.value,
        }

    }), [UASTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addUASTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            UASTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [UASTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={UASTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UASTableComponent.propTypes = wizardProps;
export default withRouter(UASTableComponent);
